<template>
  <div class="container categories">
    <div
      v-for="category in categories"
      :key="category.id"
      class="category tracking-section"
      :data-event="`${category.slug.replace(/-/g, '_')}.scroll`"
    >
      <div class="header">
        <h2 class="h3">
          {{ category.name }}
        </h2>
        <ButtonArrow
          type="nuxt-link"
          :to="`/resources-center/${category.slug}/`"
          :text="`All ${category.name}`"
          :data-event="`all_${category.slug.replace(/-/g, '_')}.click`"
          @click.native="scrollToCategories"
        />
      </div>
      <div class="body-1 description">
        {{ category.description }}
      </div>
      <div class="mobile-link">
        <ButtonArrow
          type="nuxt-link"
          :to="`/resources-center/${category.slug}/`"
          :text="`All ${category.name}`"
          :data-event="`all_${category.slug.replace(/-/g, '_')}.click`"
          @click.native="scrollToCategories"
        />
      </div>
      <div class="row body">
        <ResourceCard
          v-for="(resource, i) in category.latest.list"
          :key="i"
          :resource="resource"
          no-pin
          class="r-card col col-3 md-4"
          :event="`${category.slug.replace(/-/g, '_')}_${i + 1}.click`"
          heading="h3"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ButtonArrow from '@itbpbg/lms-components/src/components/ButtonArrow';
import ResourceCard from '../../components/Resources/ResourceCard';

export default {
  components: { ButtonArrow, ResourceCard },
  props: {
    categoriesInfo: { type: Array, required: true, default: () => [] },
  },
  computed: {
    categories() {
      let categories = this.categoriesInfo;

      if (this.$store.state.layout === 'mobile') {
        categories = categories.filter((c) => c.name !== 'Practice Exams');
      }

      return categories;
    },
  },
  methods: {
    scrollToCategories() {
      const categories = document.querySelector('.categories');
      categories.scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
  },
};
</script>

<style scoped lang="scss">
.categories {
  padding-bottom: var(--spacing-120);
  border-bottom: 1px solid rgba(230, 231, 233, 0.2);

  .category {
    margin-bottom: calc(var(--spacing-80) * 2);

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: var(--spacing-16);

      .h3 {
        margin: 0;
        color: var(--main-light);
      }

      a {
        font-size: 18px;
      }
    }

    .description {
      color: var(--main-light-shade-4);
      width: 670px;
      margin-bottom: 36px;
    }

    .mobile-link {
      display: none;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

@include bp($bp-laptop) {
  .categories .category {
    .body .r-card {
      &:last-child {
        display: none;
      }
    }

    .description {
      width: 565px;
    }
  }
}

@include bp($bp-mobile) {
  .categories {
    padding-bottom: var(--spacing-80);

    .category {
      margin-bottom: var(--spacing-80);

      .header {
        .h3 {
          width: 100%;
        }

        .btn-arrow {
          display: none;
        }
      }

      .description {
        width: 100%;
        margin-bottom: var(--spacing-16);
      }

      .body .r-card {
        margin-bottom: var(--spacing-30);

        &:last-child {
          margin-bottom: 0;
        }
      }

      .mobile-link {
        display: block;
        margin-bottom: 42px;
        font-size: 18px;
      }
    }
  }
}
</style>
